<template>
    <div class="content-wrapper primary-table">
        <div class="row">
            <div class="col-sm-12 d-md-none">
                <app-breadcrumb :page-title="$t('hiring')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>




        </div>

        <app-table
            :id="tableId"
            :options="options"
            :filtered-data="filteredData"
            @getRows="getSelectedRows"
            @getRowsAction="getSelectedRowsAction"
            @getAddButtonAction="openAddEditModal"
            @action="getListAction"
        />




        <app-candidate-add-modal
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :selected-url="selectedUrl"
            :modal-type="modalType"
            @close-modal="closeAddEditModal"
            @close-and-open-modal="closeAddEditModalAndOpen"
        />


    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import {TableChecklistHelpers} from './mixins/TableChecklistHelpers';

export default {
    extends: CoreLibrary,
    name: "DatatableWithFilter",
    mixins: [TableChecklistHelpers],
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            shareModalActive: false,
            rejectionModalActive: false,
            scheduleModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            selectedCandidates: '',
            modalType: 'add-edit-modal',
            tableId: 'checklist',
            filteredData: {
                name: '',
            },
            rowData: {},
            options: {
                name: 'ChecklistTable',
                url: actions.DATATABLE_CHECKLISTS_DATA,
                showHeader: true,
                columns: [],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit-3',
                        type: 'none',
                        className: 'edit',
                        component: 'app-candidate-add-modal',
                        modalId: 'add-edit-Modal',

                    },
                ],

                filters: [

                    {
                        "title": "Nesplněno",
                        "type": "radio",
                        "key": "filter-with-status",
                        "initValue": '1',
                        "header": {
                            "title": 'Stav',
                        },
                        "option": [
                            {
                                id: '1',
                                name: 'Nesplněno',
                            },
                            {
                                id: '2',
                                name: 'Splněno',
                            },
                        ],
                        listValueField: 'name'
                    },

                    {
                        "title": this.$t('onboarded_employee'),
                        "type": "multi-select-filter",
                        "key": "filter-with-candidate",
                        "option": [],
                    },

                    {
                        "title": this.$t('assignee'),
                        "type": "drop-down-filter",
                        "key": "filter-with-assignee",
                        "option": [],
                    },

                    {
                        "title": "Stav",
                        "type": "hidden",
                        "key": "filter-with-type",
                        "initValue": 1, // 1=internal HR checklist, 2=employee checklist
                        "option": [],
                    },

                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 15,
                showAction: true,
                actionSelectOptions: [
                    {id: '1', value: this.$t('reject_candidate')},
                    // {id: '2', value: this.$t('share_with_manager')},
                    {id: '3', value: this.$t('change_state...')},
                    // {id: '4', value: this.$t('start_hiring')},
                    {id: '5', value: this.$t('start_onboarding')},
                ],
                actionSelectedOption: 1,
                timelineState: [
                    {id: '0', value: 'Vyberte'},
                    {id: '1', value: 'Noví uchazeči'},
                    {id: '2', value: 'Předvýběr'},
                    {id: '3', value: '1. kolo'},
                    {id: '4', value: '2. kolo'},
                    {id: '5', value: '3. kolo'},
                    {id: '6', value: 'Přijmout'},
                    // @todo: axios GET FROM timeline WHERE job = x
                ],
                timelineSelectedState: 0,
                orderBy: 'desc',
                actionType: "default",
                tableShadow: false,
                emptyText: this.$t('nothing_to_show_here_hiring'),
                showEmptyAnimation: true,
                showComments: false,
                showTopBar: false,
                showTimeline: false,
                showAddButton: false,
                datatableParentId: 3, // 3=onboarding, 2=hiring, 1=talentpool
                // actionType: "dropdown",
                enableRowSelect: false,
                // tablePaddingClass: 'p-primary'
                tableClass: 'primary-table',

                onboardingSiteId: '',
                onboardingSiteUrl: '',
                currentMainTab: 1,
                mainTabs: [
                    {page: actions.DATATABLE_ONBOARDING_URL, pageName: this.$t('people'),className:'guide-step-checklist-2'},
                    {page: actions.DATATABLE_ONBOARDING_CHECKLIST_URL, pageName: this.$t('my_tasks'),className:'guide-step-checklist-1'},
                    {page: '../onboarding/stranka?id=1&job=1', pageName: this.$t('onboarding_site'),className:'guide-step-checklist-3'},
                    {page: '../onboarding/document/', pageName: this.$t('document'),className:'guide-step-checklist-4'},
                ],


            },

        }
    },
    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        this.searchAndSelectFilterOptions();
        this.getUsers();

    },
    methods: {
        // @todo: move to AdvanceDatatableTalentpool

        /**
         * for open modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        openRejectionModal() {
            this.rejectionModalActive = true;
        },
        openScheduleModal() {
            this.scheduleModalActive = true;
        },
        openShareModal() {
            this.shareModalActive = true;
        },
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * for close modal
         */
        closeAddEditModal() {
            $("#add-edit-Modal").modal('hide');
            this.isAddEditModalActive = false;
            this.searchAndSelectFilterOptions();
            this.reSetData();
        },
        closeRejectionModal() {
            this.rejectionModalActive = false;
            this.reSetData();
        },
        closeScheduleModal() {
            this.scheduleModalActive = false;
            this.reSetData();
        },
        closeShareModal() {
            this.shareModalActive = false;
            this.reSetData();
        },
        closeAddEditModalAndOpen(modal, candidate) {
            this.closeAddEditModal();

            if(modal == 'notification'){
                this.selectedRows = candidate;
                console.log(this.selectedRows);
                this.openShareModal();
            } else if (modal == 'rejection'){
                this.selectedRows = candidate;
                this.openRejectionModal();
            } else if (modal == 'schedule'){
                this.selectedRows = candidate;
                this.openScheduleModal();
            }

        },

        /**
         * for open/close filters
         */
        toggleFilters() {
            $('.filters-bar').slideToggle();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.DATATABLE_CANDIDATES_DATA}/${rowData.candidate_id}`;
                this.openAddEditModal();
            }
        },


        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.DATATABLE_CANDIDATES_DATA}/${rowData.candidate_id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#delete-modal").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    this.searchAndSelectFilterOptions();
                }).catch(({error}) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        searchAndSelectFilterOptions() {
            let url = actions.DATATABLE_CANDIDATES_DATA+'?filter_with_status=3&per_page=5000';
            this.axiosGet(url).then(response => {
                let candidate = this.options.filters.find(element => element.key === "filter-with-candidate");
console.log(response.data.data);
                candidate.option = response.data.data.map(candidate => {
                    return {
                        id: candidate.id,
                        value: candidate.fullname
                    }
                });


            });

        },

        /**
         * Change timeline_state
         */
        changeToNextState(){
            this.options.actionSelectedOption = 3;
            let candidateTimelineState = this.selectedRows.map(candidateDetails => {
                return candidateDetails.timeline_state;
            });

            candidateTimelineState++;
            this.options.timelineSelectedState = candidateTimelineState;

            this.getSelectedRowsAction();
        },


        /**
         * Show Datatable Filter by last job I have visited / by parameters in URL
         */
        getUrlParameter(name, url) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
            var regexS = "[\\?&]"+name+"=([^&#]*)";
            var regex = new RegExp( regexS );
            var results = regex.exec( url );
            return results == null ? null : results[1];
        },
        getCookie(name) {
            var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
            return match ? match[1] : null;
        },
        getDefaultJob(){
            let selectedJob = '';

            if(location.href.indexOf("?candidate") >= 0 && location.href.indexOf("&job") >= 0){
                selectedJob = parseInt(this.getUrlParameter('job', location.href));

            } else if (document.cookie.match(/^(.*;)?\s*last-selected-job\s*=\s*[^;]+(.*)?$/)){
                selectedJob = parseInt(this.getCookie('last-selected-job'));

            }

            return selectedJob;
        },
        getUsers() {
            let url = "admin/app/all-admin-users";
            this.axiosGet(url)
                .then((response) => {
                    /// this.userOptions = response.data;

                    let assignee = this.options.filters.find(element => element.key === "filter-with-assignee");
                    console.log(response.data);
                    assignee.option = response.data;

                })
                .catch(({ response }) => {})
                .finally(() => {});
        },

        /**
         * get Selected Rows
         */
        getSelectedRows(value) {
            this.selectedRows = value;
            console.log(this.selectedRows);
        },

        /**
         * do Selected Action with Selected Rows
         */
        getSelectedRowsAction() {
            console.log(this.selectedRows);

            if (this.options.actionSelectedOption == 1) {
                this.openRejectionModal();

            } else if (this.options.actionSelectedOption == 2) {
                this.openShareModal();

            } else if (this.options.actionSelectedOption == 3) {


                if(this.options.timelineSelectedState > 6){
                    console.log('change timeline_state and status');
                    // @todo: natvrdo zapsat i změnu status a to na 3
                } else {
                    console.log('change timeline_state');
                }


                let candidateIds = this.selectedRows.map(candidateDetails => {
                    return candidateDetails.id;
                });

                let selectedBulkEditData = {
                    candidate_id: Object.values(candidateIds).join(","),
                    timeline_state: parseInt(this.options.timelineSelectedState),
                };

                this.axiosPatch({
                    url: 'admin/app/bulk/edit-candidates',
                    data: selectedBulkEditData
                }).then(response => {

                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }

                }).finally(() => {
                    this.tagPreloader = false;
                    this.options.actionSelectedOption = 1;
                });

            } else if (this.options.actionSelectedOption == 4) {

                let candidateIds = this.selectedRows.map(candidateDetails => {
                    return candidateDetails.id;
                });

                let selectedBulkEditData = {
                    candidate_id: Object.values(candidateIds).join(","),
                    status: 2,
                    timeline_state: 6
                };

                this.axiosPatch({
                    url: 'admin/app/bulk/edit-candidates',
                    data: selectedBulkEditData
                }).then(response => {

                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }

                }).finally(() => {
                    this.tagPreloader = false;
                    this.options.actionSelectedOption = 1;
                });


            } else if (this.options.actionSelectedOption == 5) {

                let candidateIds = this.selectedRows.map(candidateDetails => {
                    return candidateDetails.id;
                });

                let selectedBulkEditData = {
                    candidate_id: Object.values(candidateIds).join(","),
                    status: 3,
                    timeline_state: 7
                };

                this.axiosPatch({
                    url: 'admin/app/bulk/edit-candidates',
                    data: selectedBulkEditData
                }).then(response => {

                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }

                }).finally(() => {
                    this.tagPreloader = false;
                    this.options.actionSelectedOption = 1;
                });

            } else {
                console.log('Vybrana jina akce: '+this.options.actionSelectedOption);

            }
        },

        afterSuccess(response) {
            $(".floating-bar-fixed-bottom").addClass("animate__fadeOut").delay(500).fadeOut();
            this.$hub.$emit('reload-' + this.tableId);
            this.$toastr.s(this.$t(response.data));

        },
        afterError(response) {
            $(".floating-bar-fixed-bottom").addClass("animate__fadeOut").delay(500).fadeOut();
            this.$hub.$emit('reload-' + this.tableId);
            this.$toastr.s(this.$t(response.data));

        },



        /**
         * get Status Filter
         */
        getSearchValue(value) {
                let instance = this;
                this.search = value;
                setTimeout(function () {
                    instance.$hub.$emit('reload-' + instance.tableId);
                });
            },
            getFilterValue(item) {
                this.filteredData.status = item;
                console.log('test '+item);
                this.$hub.$emit('reload-'+this.tableId);
            }

    },
}
</script>
